import React from 'react';
import { Container, Typography, Box, useTheme } from '@mui/material';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { SEO } from './SEO';
import { LegalSectionBody } from './LegalSectionBody';

const contentUseCase = new ContentUseCase();

/**
 * Terms of Service — verbatim mirror of the app's AGBScreen (v2.1).
 *
 * Needed as a public URL for the store listings: Apple requires a EULA for
 * apps with user-generated content (Guideline 1.2), and the app itself refers
 * to these terms from the moderation and appeal flows.
 */
export const TermsPage: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();
  const { terms } = contentUseCase.getLegalContent(language);

  return (
    <Container maxWidth="md" sx={{ py: theme.spacing(8) }}>
      <SEO page="terms" />

      <Typography variant="h2" component="h1" gutterBottom align="center" color="primary">
        {terms.title}
      </Typography>
      <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: theme.spacing(4) }}>
        {terms.version}
      </Typography>
      <Typography variant="body1" paragraph color="text.primary" sx={{ mb: theme.spacing(6) }}>
        {terms.intro}
      </Typography>

      {terms.sections.map((section, idx) => (
        <Box key={idx} sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {section.heading}
          </Typography>
          <LegalSectionBody body={section.body} />
        </Box>
      ))}
    </Container>
  );
};
